import React, { useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { notification, Spin } from 'antd'

import { PageOverlay } from '../../../common/components/styled'
import { useDocumentTitle } from '../../../common/hooks/effects'

import { LOGIN_WITH_EMAIL, SET_USER } from '../../graphql/mutations'
import { createSession, decodeToken } from '../../services'
import { LoginWithEmailForm } from '../forms'

const EmailLoginPage = () => {
  useDocumentTitle('Login')

  const [setUser] = useMutation(SET_USER)

  const [loginWithEmail, { loading }] = useMutation(LOGIN_WITH_EMAIL, {
    onCompleted({ loginWithEmail: { accessToken, refreshToken } }) {
      const user = decodeToken(accessToken)
      createSession(user, accessToken, refreshToken)
      setUser({ variables: { user } })
    },

    onError({ message }) {
      notification.open({
        message: 'Login with email failed.',
        description: message,
        type: 'error',
        duration: 0,
      })
    },
  })

  const handleLoginWithEmail = useCallback(
    data =>
      loginWithEmail({
        variables: { email: data.email, code: data.code },
      }),
    [loginWithEmail],
  )

  return (
    <>
      {loading && (
        <PageOverlay>
          <Spin tip="Loading..." />
        </PageOverlay>
      )}
      <LoginWithEmailForm onSubmit={handleLoginWithEmail} />
    </>
  )
}

export default EmailLoginPage
